import { render, staticRenderFns } from "./pt-form-item.vue?vue&type=template&id=ce481448"
import script from "./pt-form-item.vue?vue&type=script&lang=js"
export * from "./pt-form-item.vue?vue&type=script&lang=js"
import style0 from "./pt-form-item.vue?vue&type=style&index=0&id=ce481448&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports